import {
  CLEAR_VISIT_DATA,
  CREATE_VISIT_REMARK,
  CREATE_VISIT_REMARK_ERROR,
  CREATE_VISIT_REMARK_SUCCESS,
  CREATE_VISIT_REMARK_SUCCESS_ACTION,
  GET_REMARKS,
  GET_REMARKS_ERROR,
  GET_REMARKS_SUCCESS,
  GET_VISIT_INFO,
  GET_VISIT_INFO_SUCCESS,
  GET_VISITS,
  GET_VISITS_ERROR,
  GET_VISITS_SUCCESS,
  REMOVE_VISIT_ITEM_BY_ID,
  RESOLVE_VISIT,
  RESOLVE_VISIT_ERROR,
  RESOLVE_VISIT_SUCCESS,
  VISITS_SET_ERROR,
  CHANGE_VISIT_STATUS,
  CANCEL_VISIT,
  CANCEL_VISIT_SUCCESS,
  CANCEL_VISIT_ERROR,
  SET_IS_VISIT_STATUS_CHANGED_SUCCESS,
  VISITS_SET_DONT_REFRESH,
  text,
} from './VisitsConstants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { LOGOUT } from '../../app/authState'
import { apiErrorCodes, ID_VERIFICATION_STATUSES } from '../../utils/constants'
import { GET_PATIENT_INFO_SUCCESS } from '../charts/ChartsConstants'
import { GET_PATIENT_INFORMATION_SUCCESS } from '../patient/PatientConstants'
import {
  MANUALLY_VERIFY_ID_SUCCESS,
  SEND_VERIFICATION_INVITE_SUCCESS,
} from '../id-verification-pop-up/IDVerificationPopUpConstants'

const initialState = {
  loading: false,
  error: '',
  isVisitStatusChangedSuccess: false,
  visitData: null,
  visits: [],
  remarks: {},
  changeVisitStatusData: {
    newStatus: '',
    visitId: '',
  },
  dontRefresh: false,
}

export default (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case GET_VISITS:
    case GET_REMARKS:
    case GET_VISIT_INFO:
    case CREATE_VISIT_REMARK:
    case RESOLVE_VISIT:
    case CANCEL_VISIT:
      return {
        ...state,
        loading: true,
      }
    case CREATE_VISIT_REMARK_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const newRemark = action.payload
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { visitId: remarkVisitId } = action.extraData
      return {
        ...state,
        remarks: {
          ...state.remarks,
          [remarkVisitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.remarks[remarkVisitId],
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            remarksList: [...(state.remarks[remarkVisitId]?.remarksList || []), newRemark],
          },
        },
        loading: false,
      }
    }
    case CREATE_VISIT_REMARK_SUCCESS_ACTION: {
      return {
        ...state,
        loading: false,
      }
    }
    case GET_VISIT_INFO_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitData: action.payload,
        loading: false,
      }
    case CHANGE_VISIT_STATUS:
      return {
        ...state,
        changeVisitStatusData: {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          newStatus: action.payload.newStatus,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visitId: action.payload.visitId,
        },
      }
    case VISITS_SET_DONT_REFRESH:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        dontRefresh: action.payload,
      }
    case CLEAR_VISIT_DATA:
      return {
        ...state,
        visitData: null,
      }
    case MANUALLY_VERIFY_ID_SUCCESS:
    case SEND_VERIFICATION_INVITE_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const updatedVisitsList = JSON.parse(JSON.stringify(state.visits?.visitsList || []))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedVisitsList.forEach((visit) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (visit.Patient.PatientId === action.extraData.patientId) {
          visit.Patient.IdentityVerification = {
            ...visit.Patient.IdentityVerification,
            RequestDateTime:
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.type === SEND_VERIFICATION_INVITE_SUCCESS ? action.payload.data.RequestDateTime : null,
            Status:
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.type === SEND_VERIFICATION_INVITE_SUCCESS ?
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.payload.data.Status
              : ID_VERIFICATION_STATUSES.manuallyverified,
          }
        }
      })
      return {
        ...state,
        visits: { ...state.visits, visitsList: updatedVisitsList },
      }
    }
    case GET_PATIENT_INFO_SUCCESS:
    case GET_PATIENT_INFORMATION_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const updatedVisitsList = JSON.parse(JSON.stringify(state.visits?.visitsList || []))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedVisitsList.forEach((visit) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (visit.Patient.PatientId === action.extraData.patientId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visit.Patient.DrugScreen = action.payload.DrugScreen
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visit.Patient.IdentityVerification.Status = action.payload.IdentityVerification.Status
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visit.Patient.IdentityVerification.RequestDateTime = action.payload.IdentityVerification.RequestDateTime
        }
      })
      return {
        ...state,
        visits: { ...state.visits, visitsList: updatedVisitsList },
      }
    case GET_VISITS_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { Items = [], TotalCount = '' } = action?.payload || {}
      return {
        ...state,
        visits: { visitsList: Items, totalCount: TotalCount },
        loading: false,
      }
    case REMOVE_VISIT_ITEM_BY_ID:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const newVisitsList = state.visits.visitsList.filter(({ VisitId }) => VisitId !== action.payload)

      return {
        ...state,
        visits: { visitsList: newVisitsList, totalCount: newVisitsList?.length },
        loading: false,
      }
    case GET_REMARKS_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { visitId } = action.extraData
      return {
        ...state,
        remarks: {
          ...state.remarks,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [visitId]: { remarksList: action.payload },
          visitId,
        },
        loading: false,
      }
    case CANCEL_VISIT_SUCCESS:
    case RESOLVE_VISIT_SUCCESS:
      return {
        ...state,
        isVisitStatusChangedSuccess: true,
        loading: false,
        changeVisitStatusData: {
          newStatus: '',
          visitId: '',
        },
      }
    case SET_IS_VISIT_STATUS_CHANGED_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isVisitStatusChangedSuccess: action.payload,
      }
    case VISITS_SET_ERROR:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }
    case GET_VISITS_ERROR:
    case GET_REMARKS_ERROR:
    case RESOLVE_VISIT_ERROR:
    case CANCEL_VISIT_ERROR:
    case CREATE_VISIT_REMARK_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case apiErrorCodes.PERIOD_NOT_VALID:
            message = getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, text.PERIOD)
            break
          case apiErrorCodes.MESSAGE_NOT_VALID:
            message = getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, text.REMARK_MESSAGE)
            break
          case apiErrorCodes.VISIT_NOT_FOUND:
            message = getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, text.THE_VISIT)
            break
          case apiErrorCodes.FORBIDDEN:
            message = getUserFriendlyErrorMessage(errorCodes.CANNOT_CANCEL_VISIT)
            break

          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
